var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "accordion", attrs: { role: "tablist" } },
    _vm._l(_vm.tags, function (tag, index) {
      return _c("div", { key: tag._id, staticClass: "accordion-wrap" }, [
        tag
          ? _c(
              "div",
              {
                key: index,
                staticClass:
                  "d-flex align-items-center accordion-header justify-content-between",
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c(
                      "b-badge",
                      {
                        style: { borderColor: tag.color },
                        attrs: { href: "#", variant: "link" },
                      },
                      [_vm._v(_vm._s(tag.name.charAt(0).toUpperCase()))]
                    ),
                    _vm._v(" " + _vm._s(`${tag.name}`) + " "),
                  ],
                  1
                ),
                _c(
                  "b-dropdown",
                  { attrs: { right: "", text: "Toggle", variant: "link" } },
                  [
                    _c("router-link", {
                      attrs: { to: `/viewTag/${tag._id}`, custom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ navigate }) {
                              return [
                                _c(
                                  "b-dropdown-item",
                                  { on: { click: navigate } },
                                  [
                                    _c("span", { staticClass: "icon" }, [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../assets/icons/view.svg"),
                                          alt: "view",
                                        },
                                      }),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("lang.actions.see")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("b-dropdown-divider"),
                    _c("router-link", {
                      attrs: { to: `/editTag/${tag._id}`, custom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ navigate }) {
                              return [
                                _c(
                                  "b-dropdown-item",
                                  { on: { click: navigate } },
                                  [
                                    _c("span", { staticClass: "icon" }, [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../assets/icons/edit.svg"),
                                          alt: "edit",
                                        },
                                      }),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("lang.actions.edit")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }